// 必须得将 css 文件引入进来，这样才能打包进去
import './index.less'

import { isHelpChooseOpen, getEnergyList, getSolarList, getRecommendProducts, getProductWarrantyInfo } from '@utils/fetch.js'
import { addItem } from '@shopify/theme-cart';

class HelpToChoose{
    constructor({ pageType, goodsSolarSkuId = '', hideRecommended = false }) {
        this.pageType = pageType
        this.energyGId = ''
        this.goodsSolarSkuId = goodsSolarSkuId
        this.packageSolarId = ''

        this.lock = false
        this.hideRecommended = hideRecommended

        this.helpDOM = document.querySelector('.help-to-choose')

        this.energyInput = this.helpDOM.querySelector('[data-energy-input]')
        this.energyListWrap = this.helpDOM.querySelector('[data-energy-list-wrap]')

        this.solarListWrap = this.helpDOM.querySelector('[data-solar-list-wrap]')
        this.recommendDOM = this.helpDOM.querySelector('[data-product-recommend]')

        this.rechargeNumberDOM = this.helpDOM.querySelectorAll('[data-recharging-number]')
        this.savingEnergyNumberDOM = this.helpDOM.querySelectorAll('[data-saving-energy-number]')
        this.carbonNumberDOM = this.helpDOM.querySelectorAll('[data-carbon-number]')
        this.init()
    }
    watchScrollEvent() {
        if (this.lock) {
            const parentElement = this.energyListWrap.parentElement
            parentElement.classList.remove('active')
        }
    }
    $$(entity) {
        return entity ? document.querySelector(entity) : null
    }
    init() {
        // 判断 智能选购 功能 有没开启
        isHelpChooseOpen().then(({ data, }) => {
            if (data) {
                this.helpDOM.classList.remove('hidden')
                this.hideRecommended && this.helpDOM.querySelector('[data-product-recommendation]').classList.add('hidden')
                this.initDOM()

                window.addEventListener('scroll', this.watchScrollEvent.bind(this), false)
                window.onbeforeunload = function() {
                    window.removeEventListener('scroll', this.watchScrollEvent.bind(this))
                }
            } else {
                this.helpDOM.classList.add('hidden')
            }
        }).catch(() => {})
    }
    initDOM() {
        this.solarListWrap.innerHTML = this.renderSPSkeleton()
        this.recommendDOM.innerHTML = this.renderRecommendSkeleton(this.pageType)

        this.rechargeNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(50))
        this.savingEnergyNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        if (this.carbonNumberDOM) {
            this.carbonNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        }
        

        this.selectBtn = this.helpDOM.querySelector('[data-select-btn]')
        this.selectBtn.onclick = () => this.toggleEnergyWrap()

        this.selectBtn.disabled = true

        this.getPPSProducts()
    }
    renderNumSkeleton(width) {
        return `
            <div class="inline-block w-${width} h-60 lg:j-w-${width} lg:j-h-56 align-middle bg-[#EEE] skeleton"></div>
        `
    }
    // 获取 PPS 产品
    async getPPSProducts() {
        const { data = [] } = await getEnergyList({ goodsSolarSkuId: this.goodsSolarSkuId, pageType: this.pageType, })
        const html = this.renderPPSListDOM(data)
        this.energyListWrap.innerHTML = html

        this.energyList = document.querySelectorAll('[data-energy-item]')
        this.energyList.forEach(it => it.onclick = () => this.handleChoosePPS(it))

        this.energyGId = data[0]?.energyGId
        if (this.energyGId) {
            this.getSolarProducts()

            this.selectBtn.disabled = false
        }
    }
    toggleEnergyWrap() {
        const parentElement = this.energyListWrap.parentElement
        if (!parentElement.classList.contains('active')) {
            parentElement.classList.add('active')
            this.lock = true
        } else {
            parentElement.classList.remove('active')
        }
    }
    // 渲染 PPS DOM
    renderPPSListDOM(data) {
        let html = ''
        data.forEach(({ energyGId, goodsSkuId, goodsTitle }, index) => {
            if (index === 0) {
                this.energyInput.setAttribute('data-sku-id', goodsSkuId)
                this.energyInput.setAttribute('title', goodsTitle)
                this.energyInput.value = goodsTitle
            }
            html += `
                <li
                    class="group/item ${index === 0 ? 'active' : ''} h-70 leading-70 lg:j-h-68 lg:j-leading-68 cursor-pointer border-0 border-b-1 border-solid border-[#DDD] last-of-type:border-b-0"
                    data-enengy-id="${energyGId}"
                    data-title="${goodsTitle}"
                    data-sku-id="${goodsSkuId}"
                    data-energy-item
                >
                    <span class="group-[.active]/item:text-primary text-main line-clamp-1" title="${goodsTitle}">${goodsTitle}</span>
                </li>
            `
        })
        return html
    }
    // 切换 PPS 产品
    handleChoosePPS(it) {
        const { enengyId, skuId, title } = it.dataset
        this.energyList.forEach(v => v.classList.remove('active'))
        it.classList.add('active')

        this.energyInput.setAttribute('data-sku-id', skuId)
        this.energyInput.setAttribute('title', title)
        this.energyInput.value = title

        this.toggleEnergyWrap()

        this.solarListWrap.innerHTML = this.renderSPSkeleton()
        this.recommendDOM.innerHTML = this.renderRecommendSkeleton(this.pageType)
        
        this.rechargeNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(50))
        this.savingEnergyNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        if (this.carbonNumberDOM) {
            this.carbonNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        }

        this.energyGId = enengyId
        this.getSolarProducts()
    }
    renderSPSkeleton() {
        return `
            <li class="w-full h-168 lg:j-h-168 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></li>
            <li class="w-full h-168 lg:j-h-168 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></li>
            <li class="w-full h-168 lg:j-h-168 rounded-30 lg:j-rounded-30 bg-[#EEE] skeleton"></li>
        `
    }
    renderSPPlaceholder() {
        const { comingSoon } = this.recommendDOM.dataset
        return `
            <li class="group">
                <div class="flex items-center flex-col rounded-30 lg:j-rounded-30 bg-white w-full h-584 lg:j-w-539 lg:j-h-544">
                    <h3 class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 text-main Poppins-Medium mt-40 mb-80 lg:j-mt-40 lg:j-mb-80">${comingSoon}</h3>
                    <img
                        loading="lazy"
                        class="block lg:hidden w-[29.6vw] h-[39.6vw] object-contain"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_mb.png?v=1678778753"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        class="hidden lg:block lg:j-w-373 lg:j-h-199 object-contain"
                        src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_pc.png?v=1678778743"
                        alt=""
                    />
                </div>
            </li>
        `
    }
    // 获取 SP　产品
    async getSolarProducts() {
        const { data = [] } = await getSolarList({ energyGId: this.energyGId, goodsSolarSkuId: this.goodsSolarSkuId, pageType: this.pageType, })
        const html = this.renderSPListDOM(data)
        this.solarListWrap.innerHTML = html

        this.solarPanels = this.solarListWrap.querySelectorAll('[data-solar]') || []
        this.solarPanels.forEach(it => it.onclick = () => this.changeSelectSP(it))

        document.querySelectorAll('[name="select-solar-panel-number"]')
            .forEach(it => it.onchange = () => this.handleChooseSP(it))

        if (!data.length) {
            this.packageSolarId = null
        }
        this.getRecommendProduct()
    }
    // 渲染 SP DOM
    renderSPListDOM(data) {
        let html = ''
        if (data.length > 1) {
            this.packageSolarId = data[0].defaultPackageSolarId
            data.forEach(({ defaultPackageSolarId, goodsSolarTitle, goodsSolarImage, solarNumRespList = []}, index) => {
                let optionsHTML = ''
                solarNumRespList.forEach(({ packageSolarId, solarNum, }) => {
                    optionsHTML += `
                        <option
                            class="w-full text-center"
                            value="${packageSolarId}"
                            ${packageSolarId === defaultPackageSolarId ? 'selected' : ''}
                            data-solar-id="${packageSolarId}"
                        >${solarNum}</option>
                    `
                })

                html += `
                    <li class="group ${index === 0 ? 'active' : ''}" data-solar="${index + 1}">
                    <div class="group-[.active]:border-primary flex-center flex-col px-20 pt-12 pb-12 rounded-30 lg:j-rounded-30 border-4 lg:j-border-3 border-solid border-input lg:j-px-20 lg:j-pt-15 lg:j-pb-10 bg-white cursor-pointer h-168 lg:j-h-168">
                            <h4 class="text-main Poppins-Medium text-26 leading-30 lg:j-text-26 lg:j-leading-30 line-clamp-1 text-ellipsis">${goodsSolarTitle}</h4>
                            <div class="w-full flex-center flex-row gap-90 lg:gap-[4.6875vw] px-24 lg:j-px-35 mt-10 lg:j-mt-10">
                                <img loading="lazy" class="w-197 h-95 lg:j-w-197 lg:j-h-95 object-contain" src="${goodsSolarImage}" alt="">
                                <select class="collection-select-number" name="select-solar-panel-number">${optionsHTML}</select>
                            </div>
                        </div>
                    </li>
                `
            })
        }
        if (data.length === 1 ) {
            const { defaultPackageSolarId, goodsSolarTitle, goodsSolarImage, solarNumRespList = []} = data[0] || {}
            this.packageSolarId = defaultPackageSolarId
            let optionsHTML = ''
            solarNumRespList.forEach(({ packageSolarId, solarNum, }) => {
                optionsHTML += `
                    <option
                        class="w-full text-center"
                        value="${packageSolarId}"
                        ${packageSolarId === defaultPackageSolarId ? 'selected' : ''}
                    >${solarNum}</option>
                `
            })
            html = `
                <li class="group active block lg:hidden">
                    <div class="group-[.active]:border-primary flex-center flex-col px-20 pt-12 pb-12 rounded-30 lg:j-rounded-30 border-4 lg:j-border-3 border-solid border-input lg:j-px-20 lg:j-py-20 bg-white cursor-pointer h-168">
                        <h4 class="text-main Poppins-Medium text-26 leading-30 lg:j-text-26 lg:j-leading-30">${goodsSolarTitle}</h4>
                        <div class="w-full flex-center flex-row gap-90 lg:gap-[4.6875vw] px-24 lg:j-px-35 mt-8">
                            <img loading="lazy" class="w-197 h-95 lg:j-w-197 lg:j-h-95 object-contain" src="${goodsSolarImage}" alt="">
                            <select class="collection-select-number" name="select-solar-panel-number">${optionsHTML}</select>
                        </div>
                    </div>
                </li>
                <li class="group active hidden lg:block">
                    <div class="group-[.active]:border-primary flex-center flex-col px-20 pt-12 pb-12 rounded-30 lg:j-rounded-30 border-4 lg:j-border-3 border-solid border-input lg:j-px-20 lg:pt-0 lg:j-pb-40 bg-white cursor-pointer lg:j-h-544 overflow-hidden">
                        <img loading="lazy" class="lg:j-w-540 lg:j-h-270 object-contain" src="${goodsSolarImage}" alt="">
                        <h4 class="text-main Poppins-Medium text-26 leading-30 lg:j-text-26 lg:j-leading-39 lg:j-mt-12 lg:j-mb-28">${goodsSolarTitle}</h4>
                        <select class="collection-select-number" name="select-solar-panel-number">${optionsHTML}</select>
                    </div>
                </li>
            `
        }
        if (data.length === 0) {
            html = this.renderSPPlaceholder()
        }
        
        return html
    }
    // 切换 SP 选择
    changeSelectSP(it) {
        if (!it.classList.contains('active')) {
            const solarSelectDOM = it.querySelector('[name="select-solar-panel-number"]')
            this.handleChooseSP(solarSelectDOM)
        }
        this.solarPanels.forEach(v => v.classList.remove('active'))
        it.classList.add('active')
    }
    // 选择 SP 数量
    handleChooseSP(it) {
        const selectedIndex = it.selectedIndex || 0
        this.packageSolarId = it.options[selectedIndex].value

        this.rechargeNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(50))
        this.savingEnergyNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        if (this.carbonNumberDOM) {
            this.carbonNumberDOM.forEach(it => it.innerHTML = this.renderNumSkeleton(100))
        }

        this.recommendDOM.innerHTML = this.renderRecommendSkeleton(this.pageType)

        this.getRecommendProduct()
    }
    renderRecommendSkeleton(type) {
        // 如果是 SP 聚合页，则有 2个 产品
        if (type === 'sp_gather') {
            return `
                <ul class="w-full lg:j-w-1200 mx-auto grid grid-cols-2 gap-30 lg:j-gap-20 px-60 lg:px-0">
                    <li class="w-full flex-center flex-col px-30 py-45 lg:j-p-45 bg-white">
                        <div class="w-200 h-150 lg:j-w-360 lg:j-h-205 bg-[#EEE] skeleton"></div>
                        <div class="w-full h-78 lg:j-h-39 mt-8 lg:j-mt-8 bg-[#EEE] skeleton"></div>
                        <div class="w-full h-66 lg:j-w-240 lg:j-h-66 mt-30 lg:j-mt-30 bg-[#EEE] skeleton"></div>
                    </li>
                    <li class="w-full flex-center flex-col px-30 py-45 lg:j-p-45 bg-white">
                        <div class="w-200 h-150 lg:j-w-360 lg:j-h-205 bg-[#EEE] skeleton"></div>
                        <div class="w-full h-78 lg:j-h-39 mt-8 lg:j-mt-8 bg-[#EEE] skeleton"></div>
                        <div class="w-full h-66 lg:j-w-240 lg:j-h-66 mt-30 lg:j-mt-30 bg-[#EEE] skeleton"></div>
                    </li>
                </ul>
            `
        }
        return `
            <ul class="w-full lg:j-w-1200 mx-auto grid grid-cols-1 gap-30 lg:j-gap-20 px-60 lg:px-0">
                <li class="flex-center flex-col px-30 py-45 lg:j-p-45 bg-white rounded-30 lg:j-rounded-30">
                    <div class="w-full h-54 lg:j-w-530 lg:j-h-54 bg-[#EEE] skeleton"></div>
                    <div class="w-336 h-254 lg:j-w-520 lg:j-h-308 mt-12 lg:j-mt-12 mb-16 lg:j-mb-16 bg-[#EEE] skeleton"></div>
                    <div class="w-full h-39 lg:j-w-418 lg:j-h-36 mb-20 lg:j-mb-20 bg-[#EEE] skeleton"></div>
                    <div class="w-300 h-66 lg:j-w-300 lg:j-h-66 bg-[#EEE] skeleton"></div>
                </li>
            </ul>
        `
    }
    async getRecommendProduct() {
        const { data: { chargingDuration = 0, powerSaving = 0, allCarbonNum = 0, cusPageDetailResps = [] } } = await getRecommendProducts({
            energyGId: this.energyGId,
            packageSolarId: this.packageSolarId,
            pageType: this.pageType,
        }) || {}
        
        this.rechargeNumberDOM.forEach(it => it.innerHTML = chargingDuration?.toLocaleString(window.Shopify.locale) || 0)
        this.savingEnergyNumberDOM.forEach(it => it.innerHTML = powerSaving?.toLocaleString(window.Shopify.locale) || 0)
        if (this.carbonNumberDOM) {
            this.carbonNumberDOM.forEach(it => it.innerHTML = allCarbonNum?.toLocaleString(window.Shopify.locale) || 0)
        } 

        if (cusPageDetailResps.length === 0) {
            this.recommendDOM.innerHTML = this.renderSinglePlaceholder()
        }

        // 如果是 SP 聚合页，则有 2个 产品
        if (cusPageDetailResps.length === 2) {
            this.recommendDOM.innerHTML = this.renderTwoProducts(cusPageDetailResps)
        }
        if (cusPageDetailResps.length === 1) {
            this.recommendDOM.innerHTML = this.renderSingleProduct(cusPageDetailResps[0], this.pageType)
        }

        document.querySelectorAll('[data-add-to-cart]').forEach( it => it.onclick = () => {
            it.classList.add('btn--loading')
            const { id, addCartText, goodsPrice, goodsTitle } = it.dataset
            this.addToCart(+id)

            // 埋点事件
            window.dataLayer?.push({
                event: "ga4Event",
                event_name: "add_to_cart",
                event_parameters: {
                  current_page: "earth day activity page",
                  button_name: addCartText, 
                //   currency: $currencyCode, 
                  value: goodsPrice,
                  items: [{
                    // currency: $currencyCode,
                    item_id: id,
                    item_name: goodsTitle,
                    // item_category: $itemCategory,
                    // item_variant: $itemVariant,
                    // item_brand: $itemBrand,
                    price: goodsPrice,
                    quantity: 1,
                    // discount: $discount
                  }]
                }
            });
        })
    }
    renderSinglePlaceholder() {
        const { comingSoon } = this.recommendDOM.dataset
        return `
            <ul class="w-full lg:j-w-1200 mx-auto grid grid-cols-1 gap-30 lg:j-gap-20 px-60 lg:px-0">
                <li class="flex-center flex-col px-30 py-45 lg:j-p-45 bg-white rounded-30 lg:j-rounded-30">
                    <div class="flex items-center flex-col rounded-30 lg:j-rounded-30 bg-white w-full h-584 lg:j-w-539 lg:j-h-443">
                        <h3 class="text-32 leading-48 lg:j-text-24 lg:j-leading-36 text-main Poppins-Medium mt-40 mb-80 lg:j-mt-40 lg:j-mb-80">${comingSoon}</h3>
                        <img
                            loading="lazy"
                            class="block lg:hidden w-[29.6vw] h-[39.6vw] object-contain"
                            src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_mb.png?v=1678778753"
                            alt=""
                        />
                        <img
                            loading="lazy"
                            class="hidden lg:block lg:j-w-373 lg:j-h-199 object-contain"
                            src="https://cdn.shopify.com/s/files/1/0550/0524/9633/files/no-result_pc.png?v=1678778743"
                            alt=""
                        />
                    </div>
                </li>
            </ul>
        `
    }
    renderSingleProduct({ goodsImage, goodsTitle, goodsDetailUrl, goodsSkuId, goodsPrice, }, pageType) {
        if (pageType !== 'sp_gather') {
            this.helpDOM.querySelector('[data-product-recommend-title]').classList.add('hidden')
        }
        
        const { sectionTitle, addCartText, } = this.recommendDOM.dataset
        return `
            <ul class="w-full lg:j-w-1200 mx-auto grid grid-cols-1 gap-30 lg:j-gap-20 px-60 lg:px-0">
                <li class="flex-center flex-col px-30 py-45 lg:j-p-45 bg-white rounded-30 lg:j-rounded-30">
                    ${ pageType !== 'sp_gather' ? `<h3 class="text-36 leading-54 lg:j-text-36 lg:j-leading-54 text-main Poppins-SemiBold">${sectionTitle}</h3>` : ''}
                    <img
                        class="w-336 h-254 lg:j-w-520 lg:j-h-308 object-contain mt-12 lg:j-mt-12 mb-16 lg:j-mb-16"
                        src="${goodsImage}"
                        alt=""
                    />
                    <h3 class="text-26 leading-39 lg:j-text-26 lg:j-leading-39 text-black Poppins-Medium mb-20 lg:j-mb-20 text-center line-clamp-1 text-ellipsis" title="${goodsTitle}">${goodsTitle}</h3>
                    <button
                        class="z-button-fill-middle"
                        data-add-to-cart
                        data-goods-title="${goodsTitle}"
                        data-id="${goodsSkuId}"
                        data-add-cart-text="${addCartText}"
                        data-goods-price="${goodsPrice}"
                    >${addCartText} <i class="iconfont jackery-icon-arrow-right"></i></button>
                </li>
            </ul>
        `
    }
    renderTwoProducts(data) {
        const { addCartText, } = this.recommendDOM.dataset
        let html = '<ul class="w-full lg:j-w-1200 mx-auto grid grid-cols-2 gap-30 lg:gap-[20px] px-60 lg:px-0">'
        data.forEach(({ goodsImage, goodsTitle, goodsSkuId, goodsPrice, }) => {
            html += `
                <li class="flex-center flex-col px-30 py-45 lg:j-p-45 bg-white">
                    <img
                        class="w-200 h-150 lg:j-w-360 lg:j-h-205 object-contain mb-8 lg:j-mb-8"
                        src="${goodsImage}"
                        alt=""
                    />
                    <h3 class="text-26 leading-39 lg:j-text-26 lg:j-leading-39 text-black Poppins-Medium mb-30 lg:j-mb-30 text-center line-clamp-2 lg:line-clamp-1 text-ellipsis" title="${goodsTitle}">${goodsTitle}</h3>
                    <button
                        class="z-button-fill-middle"
                        data-add-to-cart
                        data-goods-title="${goodsTitle}"
                        data-id="${goodsSkuId}"
                        data-add-cart-text="${addCartText}"
                        data-goods-price="${goodsPrice}"
                    >${addCartText} <i class="iconfont jackery-icon-arrow-right"></i></button>
                </li>
            `
        })
        return html + '</ul>'
    }

    matchContent(param) {
        const RegExp = /\[([^\]]*)\]/ // 摘取 [] 内的内容
        const result = param.match(RegExp)
        return result ? result[1] : ''
    }
    // 加入购物车
    async addToCart(id, properties = {}) {
        const { data: { extendedWarranty, defaultWarranty, productWarranty, } } = await getProductWarrantyInfo({ skuId: id, })
        const ex = this.matchContent(extendedWarranty)
        const de = this.matchContent(defaultWarranty)

        const warrantyKey = `${howToChoose.warrantyKey}`
        const warrantyContent = `${howToChoose.warrantyContent}`
        let warrantyProperty = Object.create(null)
        if (productWarranty && (ex || de)) {
            const total = Number(ex) + Number(de);
            warrantyProperty[warrantyKey] = warrantyContent.replace("{{ total }}", total).replace("{{ extended }}", ex)
        }

        let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        addItem(id, {
            quantity: 1,
            properties: {
                SmartShopOrder: '',
                // ...warrantyProperty,  暂时不需要了
                ...properties,
            },
        }).then(response => {
            // 3.0 版本
            if (cart) {
                cart.renderContents(response)
            }
            // 2.0 版本
            else {
                const lang = document.querySelector('html').getAttribute('lang')
                // 如果是日本站，则加购后跳转
                if (lang === 'jp') {
                    window.location.href = '/cart'
                } else {
                    $('body').trigger('added.ajaxProduct');
                }
            }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')

            document.querySelectorAll('[data-add-to-cart]').forEach( it => it.classList.remove('btn--loading'))
        });
    }
}

export default HelpToChoose
